<script lang="ts">
    
    import { getContext, SvelteComponent } from "svelte";
    import type { Answer } from "../../global";
    import type { Question } from "../../Model/Question";
    import QuestionAnswerDate from "./QuestionAnswerDate.svelte";
    import QuestionAnswerGrid from "./QuestionAnswerGrid.svelte";
    import QuestionAnswerOptions from "./QuestionAnswerOptions.svelte";
    import QuestionAnswerText from "./QuestionAnswerText.svelte";
    import SectionAnswers from "./SectionAnswers.svelte";

    export let question: Question;

    const getAnswer = getContext('getAnswer') as (questionId: string) => Answer;
    const answerComponentsMap = {
        text        : QuestionAnswerText,
        data        : QuestionAnswerDate,
        bool        : QuestionAnswerOptions,
        multiple    : QuestionAnswerOptions,
        grid        : QuestionAnswerGrid,
    };
    
    let answer: Answer;
    let answerComponent: typeof SvelteComponent;
    let showSubsections = false;

    $: setupComponent(question);

    function setupComponent(question: Question): void {
        answer = getAnswer(question.id);
        if (question.sections.length > 0) {
            showSubsections = true;
        }
        
        answerComponent = answerComponentsMap[question.type];
        
    }

</script>

<style lang="scss">

    .question {
        padding-left: 1rem;
        border-left: 4px solid #ddd;
        margin-top: 1rem;
    }

</style>

<div class="question">
    <svelte:component this={answerComponent} {question} {answer} />

    {#if showSubsections}
        {#each question.sections as section}
            <SectionAnswers {section} /> 
        {/each}
     
    {/if}
</div>

